<template>
    <div class="information">
        <van-dropdown-menu>
            <van-dropdown-item get-container="body" v-model="message_request.location" :options="locale"  @change="onRefresh()"/>
            <van-dropdown-item get-container="body" v-model="message_request.type" :options="category"  @change="onRefresh()"/>
            <van-dropdown-item get-container="body" v-model="message_request.status" :options="state"  @change="onRefresh()"/>
            <van-dropdown-item get-container="body" v-model="message_request.progress" :options="progress"  @change="onRefresh()"/>
        </van-dropdown-menu>
        <div class="list">
            
            <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
                <van-list
                    v-model="loading"
                    :finished="finished"
                    finished-text="没有更多了"
                    @load="onLoad"
                    
                    :error.sync="error"
                    error-text="请求失败，点击重新加载"
                >
                    <listProject v-for="(item,index) in records" :key="index" :record="item"></listProject>
                </van-list>
            </van-pull-refresh>
        </div>
    </div>
    <!-- <van-popup position="bottom">
    <van-picker
        show-toolbar
        :columns="editBlackColumns"
        @cancel="editBlackPicker = false"
        @confirm="editBlackConfirm"
    />
    </van-popup> -->
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import Vue from 'vue';
import { DropdownMenu, DropdownItem } from 'vant';
import listProject from '../components/listProject.vue';

Vue.use(DropdownMenu);
Vue.use(DropdownItem);
export default {
    name: "InvestmentIndex",
    components: {
        listProject
    },
    data() {
        return {
            loading: false,
            finished: false,
            refreshing: false,
            error: false,
            error_true: false,
            locale: [
                { text: '建设地点', value: '' },
            ],
            category: [
                { text: '项目类别', value: '' },
            ],
            state: [
                { text: '项目状态', value: '' },
                { text: '审核中', value: 1 },
                { text: '审核通过', value: 3 },
                { text: '审核驳回', value: 2 },
            ],
            progress: [
                { text: '项目进度', value: '' },
            ],
            message_request: {
                location: '',
                type: '',
                progress: '',
                status: '',
                current: 0,
                size: 10,
            },
            records: []
        };
    },
    computed: {
        ...mapGetters('investment', ['getPendingOption'])
    },
    created() {
        this.setInvestmentTitle('项目管理列表');
        this.message_request.location = this.getPendingOption.location
        this.message_request.type = this.getPendingOption.type
        this.message_request.progress = this.getPendingOption.progress
        this.message_request.status = this.getPendingOption.status

        this.getAllLocation().then(res => {
            for (const key in res) {
                this.locale.push(
                    {
                        text: res[key],
                        value: key
                    }
                )
                
            }
            
        })
        this.getAllProjectType({type: 1}).then(res => {
            res.forEach(element => {
                this.category.push(
                    {
                        text: element.name,
                        value: element.type
                    }
                )
            });
            
        })
        this.getProgressAll().then(res => {
            for (let key in res) {
                this.progress.push(
                    {
                        text: res[key],
                        value: key
                    }
                )
            }
        })
    },
    watch: {},
    methods: {
        ...mapActions('investment', [
            'setInvestmentTitle',
            'getAllLocation',
            'getAllProjectType',
            'getProgressAll',
            'getProjectList',
            "setPendingOption"
        ]),
        onLoad() {
            console.log('加载下一页')
            if(!this.error_true){
                this.message_request.current++
            }
            this.refresh()
        },
        //下拉刷新时触发
        onRefresh() {
            this.setPendingOption({
                location: this.message_request.location,
                type: this.message_request.type,
                status: this.message_request.status,
                progress: this.message_request.progress,
            })
            this.message_request.current = 1
            this.records = []
            this.refresh()
        },
        refresh(){
            this.getProjectList(this.message_request).then(res=>{
                this.refreshing = false
                this.loading = false
                this.error_true = false
                if(res.pages > this.message_request.current){
                    this.finished = false
                }else{
                    this.finished = true
                }
                
                this.records = this.records.concat(res.records)

            }).catch(res=>{
                this.refreshing = false
                this.loading = false
                this.finished = false
                this.error=true
                this.error_true = true
            })
        }
    },
    mounted() {},
};
</script>

<style lang="less" scoped>
.information {
    min-height: 100%;
    font-family: PingFangSC-Regular;
    padding-bottom: 42px;
    background: #F5F6F9;

    .list{
        padding: 0 12px;
    }
    /deep/.van-dropdown-menu__bar{
        justify-content: flex-start;
    }
    /deep/.van-dropdown-menu__item{
        flex: none;
        margin-right: 20px;
    }
    /deep/.van-ellipsis{
        white-space: nowrap;
        max-width: 60px;
    }
}
</style>